module.exports = __webpack_public_path__ + "img/nature-11.7136ac61.jpg";